import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NavBarMobileComponent } from './pages/layout/navbar/nav-bar-mobile/nav-bar-mobile.component';
import { Sidebar2CheckboxComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-checkbox/sidebar2-checkbox.component';
import { Sidebar2ClientsSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-clients-sub-menu/sidebar2-clients-sub-menu.component';
import { Sidebar2ContactsSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-contacts-sub-menu/sidebar2-contacts-sub-menu.component';
import { Sidebar2EstimatesSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-estimates-sub-menu/sidebar2-estimates-sub-menu.component';
import { Sidebar2ExploreSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-explore-sub-menu/sidebar2-explore-sub-menu.component';
import { Sidebar2JobsSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-jobs-sub-menu/sidebar2-jobs-sub-menu.component';
import { Sidebar2LeadsSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-leads-sub-menu/sidebar2-leads-sub-menu.component';
import { Sidebar2RfqSubMenuComponent } from './pages/layout/sidebar.2/sidebar2-mobile-sub-menu/sidebar2-rfq-sub-menu/sidebar2-rfq-sub-menu.component';
import { HttpLoaderFactory } from './utils/helper-functions/translate.functions';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        RouterModule,
    ],
    declarations: [
        NavBarMobileComponent,
        Sidebar2LeadsSubMenuComponent,
        Sidebar2EstimatesSubMenuComponent,
        Sidebar2JobsSubMenuComponent,
        Sidebar2CheckboxComponent,
        Sidebar2RfqSubMenuComponent,
        Sidebar2ClientsSubMenuComponent,
        Sidebar2ContactsSubMenuComponent,
        Sidebar2ExploreSubMenuComponent,
    ],
    exports: [
        NavBarMobileComponent,
        Sidebar2LeadsSubMenuComponent,
        Sidebar2EstimatesSubMenuComponent,
        Sidebar2JobsSubMenuComponent,
        Sidebar2CheckboxComponent,
        Sidebar2RfqSubMenuComponent,
        Sidebar2ClientsSubMenuComponent,
        Sidebar2ContactsSubMenuComponent,
        Sidebar2ExploreSubMenuComponent,
    ],
})
export class Nav2LayoutComponentsModule {}
